import { Button, ButtonMode, Divider, Icon, ICONS, Tooltip } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React, { ReactElement } from 'react';
import { USER_LIMIT_EXCEEDED_MESSAGE_COMPANY_PAGE } from '../../../pages/MyContent/WatchlistsTab/Watchlist/Watchlist.logic';

import styles from './WatchlistPopupFooter.module.scss';

const cx = classNames.bind(styles);

interface WatchlistPopupFooterProps {
  hasWatchlists: boolean | undefined;
  isUserLimitExceeded: boolean;
  onCreateNewWatchlistClick: () => void;
}

const WatchlistPopupFooter = ({
  hasWatchlists,
  isUserLimitExceeded,
  onCreateNewWatchlistClick,
}: WatchlistPopupFooterProps): ReactElement => {
  return (
    <div className={cx('body')}>
      {hasWatchlists && <Divider />}
      <Tooltip content={USER_LIMIT_EXCEEDED_MESSAGE_COMPANY_PAGE} disabled={!isUserLimitExceeded}>
        <div>
          <Button
            className={cx('action')}
            mode={ButtonMode.TERTIARY}
            onClick={onCreateNewWatchlistClick}
            ariaLabel="Create New Watchlist"
            disabled={isUserLimitExceeded}
          >
            <Icon width={12} height={12} name={ICONS.Plus} />
            Create New Watchlist
          </Button>
        </div>
      </Tooltip>
    </div>
  );
};

export default WatchlistPopupFooter;
